import IMProducts from './IMProducts';

export default IMProducts;
